import React from 'react';

const Button = ({ icon, text, handleClick, isActive, iconOffset, actionsRequired }) => {
	return (
		<button
			className={`flex flex-row items-center rounded-[4px] font-inter w-full p-2 gap-2 ${
				isActive && 'bg-[#e5edff]'
			}`}
			onClick={handleClick}
		>
			<div className={`w-4 h-4 relative ${iconOffset ? 'top-[2px]' : ''}`}>
				<img src={icon} alt="" width="24" height="24"></img>
				{actionsRequired && (
					<div className="absolute top-[-4px] right-[-2px] w-2 h-2 bg-red-500 rounded-full">
						<span className="sr-only">Action required</span>
					</div>
				)}
			</div>
			<span className="text-[16px]/[16px]">{text}</span>
		</button>
	);
};

export default Button;
